/** External dependencies */
// import { Handlebars } from 'handlebars/runtime';

/** Internal dependencies */
import { showItem } from "./utilities";

export function updateItems(parent, result) {
  const items = result.data;
  const itemsContainer = parent.querySelector("[data-items]");
  const tmpl = parent.getAttribute("data-tmpl");

  // This function is only called if `result` is an array
  items.forEach((item) => {
    const html = Handlebars.partials[tmpl](item);

    if (parent.getAttribute("data-rest-masonry")) {
      const $elems = jQuery(html);
      jQuery(".grid").append($elems).masonry("appended", $elems);
    } else {
      itemsContainer.insertAdjacentHTML("beforeend", html);
    }

    if (window.lazyLoadInstance) {
      window.lazyLoadInstance.update();
    }
    showItem(item.id);
  });
}
